import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'reply_behavior'

export default function ReplyBehaviorPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "How do you feel when someone doesn't reply?",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.replyBehavior.heading')}
      buttons={[
        {
          text: t('pages.onboarding.replyBehavior.options.overthink'),
          value: 'overthink',
        },
        {
          text: t('pages.onboarding.replyBehavior.options.waitPatiently'),
          value: 'waitPatiently',
        },
        {
          text: t('pages.onboarding.replyBehavior.options.followUp'),
          value: 'followUp',
        },
        {
          text: t('pages.onboarding.replyBehavior.options.moveOn'),
          value: 'moveOn',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
